import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { deactivateCharm, getActiveCharm, toggleCharm } from 'owa-header-store';
import { format } from 'owa-strings';
import * as React from 'react';
var classNames = require('classnames/bind');
var styles = require('./Header.scss');
var HeaderCharm = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderCharm, _super);
    function HeaderCharm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCharmClicked = function (evt) {
            toggleCharm(_this.props.behavior.charm);
        };
        _this.onDismiss = function () {
            deactivateCharm(_this.props.behavior.charm);
        };
        return _this;
    }
    HeaderCharm.prototype.render = function () {
        var behavior = this.CharmBehavior;
        var _a = this.props, getBadgeCount = _a.getBadgeCount, className = _a.className, title = _a.title, ariaLabel = _a.ariaLabel, activeClassName = _a.activeClassName, ariaLabelWithBadgeCount = _a.ariaLabelWithBadgeCount;
        var badgeCount = !!getBadgeCount ? getBadgeCount() : 0;
        var charmStyles = classNames(className, styles.charm, behavior.isActive && activeClassName, behavior.isActive && styles.charmActive);
        var ariaProps = {
            role: AriaRoles.menuitem,
            expanded: behavior.isActive,
            hasPopup: true,
            label: badgeCount > 0 && ariaLabelWithBadgeCount
                ? format(ariaLabelWithBadgeCount, badgeCount)
                : ariaLabel,
        };
        return (React.createElement("button", tslib_1.__assign({ className: charmStyles, onClick: behavior.charmOnClick, title: title, "data-is-focusable": "true" }, generateDomPropertiesForAria(ariaProps)),
            this.renderGlyph(),
            behavior.hostedContent,
            badgeCount > 0 && React.createElement("div", { className: styles.badgeCounter }, badgeCount)));
    };
    Object.defineProperty(HeaderCharm.prototype, "CharmBehavior", {
        get: function () {
            var behavior = this.props.behavior;
            if (!behavior) {
                return {
                    isActive: false,
                    charmOnClick: null,
                    hostedContent: null,
                };
            }
            var controlledBehavior = behavior;
            var flexPaneBehavior = behavior;
            var isActive = controlledBehavior.isActive !== undefined
                ? controlledBehavior.isActive
                : flexPaneBehavior.charm === getActiveCharm();
            return {
                isActive: isActive,
                charmOnClick: controlledBehavior.onClick || this.onCharmClicked,
                hostedContent: controlledBehavior.content ||
                    (isActive &&
                        flexPaneBehavior.paneComponent && (React.createElement(flexPaneBehavior.paneComponent, { onDismiss: this.onDismiss }))),
            };
        },
        enumerable: true,
        configurable: true
    });
    HeaderCharm.prototype.renderGlyph = function () {
        var iconProps = this.props.icons;
        var isShellHeader = isControlFeatureEnabled('fwk-o365shellheader');
        if (iconProps.iconName) {
            return [
                React.createElement(Icon, { className: isShellHeader ? styles.suiteCharmIcon : styles.charmIcon, iconName: iconProps.iconName, key: "base" }),
                React.createElement(Icon, { className: isShellHeader ? styles.suiteHoverCharmIcon : styles.hoverCharmIcon, iconName: iconProps.hoverIconName || iconProps.iconName, key: "hover" }),
            ];
        }
        else {
            var charmContent = this.props.icons.charmContent;
            return charmContent;
        }
    };
    HeaderCharm = tslib_1.__decorate([
        observer
    ], HeaderCharm);
    return HeaderCharm;
}(React.Component));
export default HeaderCharm;
//# sourceMappingURL=HeaderCharm.js.map